import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import { DocType } from '@tencent/docs-mime-types';
import { getXsrfToken } from "../cgi/cookies";
import { DriveRequest } from "../common/drive-request";
import { requestV2Cgi } from "../data-source/network-request";
import { DEFAULT_CREATOR_DOMAIN, DEFAULT_DOMAIN_ID, DocSource, DRIVE_FILE_KIND, DriveFileType } from "../model/drive-file";
/**
 * 请求容量页列表
 */
export var StorageListRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(StorageListRequest, _DriveRequest);
  var _super = _createSuper(StorageListRequest);
  function StorageListRequest() {
    _classCallCheck(this, StorageListRequest);
    return _super.apply(this, arguments);
  }
  _createClass(StorageListRequest, [{
    key: "request",
    value: function request(payload) {
      return requestV2Cgi(payload);
    }
  }, {
    key: "getPayload",
    value: function getPayload(params) {
      return {
        method: 'post',
        url: "/v2/list/capacity?xsrf=".concat(getXsrfToken()),
        data: {
          offset: params.offset,
          limit: params.limit,
          sort_type: params.orderType,
          xsrf: getXsrfToken()
        }
      };
    }
  }, {
    key: "getResult",
    value: function getResult(response) {
      var _this = this;
      return {
        items: response.result.fileItems.map(function (item) {
          return _this.getDriveFile(item);
        }),
        hasNext: response.result.count >= this.params.limit
      };
    }
  }, {
    key: "getDriveFile",
    value: function getDriveFile(item) {
      var _ref;
      var meta = item.meta,
        entry = item.entry,
        mimeType = item.mimeType;
      var ownerVipInfo = JSON.parse(meta.ownerVipInfo || 'null');
      return {
        kind: DRIVE_FILE_KIND,
        id: meta.fileId,
        title: meta.name,
        collaborationFlag: meta.collaborationFlag,
        createTs: timestamp(meta.createTime),
        creator: {
          uid: meta.creator,
          nick: entry.creatorNick
        },
        docType: DocType.Unknown,
        iconUrl: meta.iconUrl,
        lastBrowseTs: timestamp(meta.accessTime),
        lastDeleteTs: timestamp(entry.deleteTime),
        lastModifyTs: timestamp(meta.modifyTime),
        lastModifier: {
          uid: meta.modifyUid,
          nick: meta.modifierNick
        },
        mimeType: mimeType,
        owner: {
          uid: meta.owner,
          nick: meta.ownerNick,
          avatarFrameUrl: ownerVipInfo === null || ownerVipInfo === void 0 ? void 0 : ownerVipInfo.avatar_frame_url,
          expiredStatus: ownerVipInfo === null || ownerVipInfo === void 0 ? void 0 : ownerVipInfo.expired_status,
          vipLevel: ownerVipInfo === null || ownerVipInfo === void 0 ? void 0 : ownerVipInfo.vip_level,
          renewalStatus: ownerVipInfo === null || ownerVipInfo === void 0 ? void 0 : ownerVipInfo.renewal_status
        },
        originParentId: (_ref = entry.sourceParentId) !== null && _ref !== void 0 ? _ref : '/',
        parentId: meta.fileParentId,
        thirdAppId: meta.sourceAppid,
        isOwnedByMe: true,
        size: Number(entry.size),
        personalizeInfo: meta.personalizeInfo,
        status: meta.status,
        ext: entry.ext,
        driveFileType: DriveFileType.CLOUD,
        clientId: null,
        creatorDomainId: DEFAULT_CREATOR_DOMAIN,
        domainId: DEFAULT_DOMAIN_ID,
        isCollected: entry.isStarred,
        isPinned: null,
        lastCollectTs: 0,
        lastPinnedTs: 0,
        officialAuthInfo: meta.officialAuthInfo,
        policy: meta.policy,
        source: DocSource.Personal,
        tenantId: meta.tenantId,
        thumbnailUrl: meta.thumbnailUrl,
        url: entry.docUrl,
        weDriveInfo: null,
        groupChatKey: null,
        groupName: null
      };
    }
  }]);
  return StorageListRequest;
}(DriveRequest);
function timestamp(input) {
  return Math.floor(Number(input) / 1000);
}
//# sourceMappingURL=storage-list.js.map